export default {
    name: 'text-seo',
    data(){
        return{
            openReadMore: false,
        }
    },
}
